export const DeviceMessageType = {
    Init: 0x00,
    VideoFrame: 0x01,
    Screenshot: 0x02,
    Pong: 0x41,
} as const;

export const FrontendMessageType = {
    KeyboardInput: 0x10,
    MouseClick: 0x11,
    MouseMove: 0x12,
    MouseWheel: 0x13,
    ControlMessage: 0x20,
    Ping: 0x40,
} as const;

export type DeviceMessageTypeEnum = (typeof DeviceMessageType)[keyof typeof DeviceMessageType];

export const WsVideoCodec = {
    H264: 0x01,
    H264High444: 0x02,
    H265: 0x10,
    H265Main10: 0x11,
    H265Rext8_444: 0x12,
    H265Rext10_444: 0x13,
    Av1Main8: 0x20,
    Av1Main10: 0x21,
    Av1High8_444: 0x22,
    Av1High10_444: 0x23,
    Vp8: 0x30,
    Vp9: 0x31,
} as const;

export enum ChannelName {
    Send = "upload",
    Receive = "download",
    Connect = "connect",
    Disconnect = "disconnect",
}
export enum StreamingMode {
    H264 = "h264",
    Screenshot = "screenshot",
    Adaptive = "adaptive",
}
export enum ConnectionStatus {
    Connecting = "connecting",
    Connected = "connected",
    Disconnected = "disconnected",
    Error = "error",
}
export enum LastVideoHwAccel {
    PreferHardware = "prefer-hardware",
    PreferSoftware = "prefer-software",
    NoPreference = "no-preference",
}

export interface ScreenViewClientConfig {
    sessionId: string;
}

export interface ScreenViewClientCallbacks {
    onScreenshot?: (imageData: ImageData) => void;
    onError?: (error: string, metadata?: unknown) => void;
    onWarning?: (warning: string, metadata?: unknown) => void;
    onConnected?: () => void;
    onDisconnected?: () => void;
    onStatusChange?: (status: ConnectionStatus) => void;
}

export interface StreamInitMessage {
    codec: number;
    width: number;
    height: number;
}
